import { useQuery, UseQueryOptions } from 'react-query'

import {
  getHelpCenterArticleDetail,
  getHelpCenterArticles,
  getHelpCenterCategories
} from 'app/services/Api/helpCenter'
import Deserializer from 'app/services/Deserializer'

import { helpCenterKeys } from './help-center.keys'

export const helpCenterConfig = {
  getHelpCenterCategories: {
    key: helpCenterKeys.getHelpCenterCategories,
    request: async ({ queryKey }) => {
      const [_key, _, params] = queryKey

      const resp = await getHelpCenterCategories(params)

      return resp
    }
  },
  getHelpCenterArticles: {
    key: helpCenterKeys.getHelpCenterArticles,
    request: async ({ queryKey }) => {
      const [_key, _, params] = queryKey

      const resp = await getHelpCenterArticles(params)
      const articles = await Deserializer.deepDeserialize(resp?.articles)

      return { articles, pagy: resp.pagy }
    }
  },
  getHelpCenterArticleDetail: {
    key: helpCenterKeys.getHelpCenterArticleDetail,
    request: async ({ queryKey }) => {
      const [_key, _, slug] = queryKey

      const resp = await getHelpCenterArticleDetail(slug)
      const helpCenterCategories = await Deserializer.deepDeserialize(
        resp?.help_center_categories
      )

      return { ...resp, help_center_categories: helpCenterCategories }
    }
  }
}

interface UseGetHelpCenterCategoriesProps {
  params: HelpCenterCategoryParams
  options?: UseQueryOptions<HelpCenterCategoryModel[]>
}

export const useGetHelpCenterCategories = (
  props: UseGetHelpCenterCategoriesProps
) => {
  const { params, options } = props
  const { getHelpCenterCategories: config } = helpCenterConfig || {}

  const state = useQuery<HelpCenterCategoryModel[]>(
    config.key(params),
    config.request,
    {
      ...options
    }
  )

  return state
}

interface UseGetHelpCenterArticlesProps {
  params: HelpCenterArticlesParams
  options?: UseQueryOptions<HelpCenterPreviewArticlePaginationModel>
}

export const useGetHelpCenterArticles = (
  props: UseGetHelpCenterArticlesProps
) => {
  const { params, options } = props
  const { getHelpCenterArticles: config } = helpCenterConfig || {}

  const state = useQuery<HelpCenterPreviewArticlePaginationModel>(
    config.key(params),
    config.request,
    {
      ...options
    }
  )

  return state
}

interface UseGetHelpCenterArticleDetailProps {
  slug: string
  options?: UseQueryOptions<HelpCenterDetailArticleModel>
}

export const useGetHelpCenterArticleDetail = (
  props: UseGetHelpCenterArticleDetailProps
) => {
  const { slug, options } = props
  const { getHelpCenterArticleDetail: config } = helpCenterConfig || {}

  const state = useQuery<HelpCenterDetailArticleModel>(
    config.key(slug),
    config.request,
    {
      ...options
    }
  )

  return state
}
